import { cateringModulePermission, websiteModule } from '../DashboardModule/modulepermissions';
import {
  dashboardPosModule,
  orderHubPosModule,
  paymentPosModule,
  tableLayoutPosModule,
} from '../PosModules/moduleFeatures';
import {
  menuBoardPermission,
  payrollModulePermissions,
  reviewManagementFeaturePermission,
  roleAndPermissionsModulePermissions,
  settingsModulePermission,
  tenderCashDrawerFeatures,
  tipsPoolingModulePermissions,
  visibleCheckPermissions,
  settingsPosFeaturePermissions,
} from './DashboardPermissions';

export const defaultManagerPermissions = [
  {
    id: 173,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: null,
    featureId: null,
    key: 'mom-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 174,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 1,
    featureId: null,
    key: 'my-restaurant-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 175,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 2,
    featureId: null,
    key: 'my-account-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 176,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 3,
    featureId: null,
    key: 'timecards-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 177,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 4,
    featureId: null,
    key: 'employee-availability-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 178,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 5,
    featureId: null,
    key: 'employee-time-off-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 179,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: null,
    key: 'employee-management-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 180,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 7,
    featureId: null,
    key: 'roles-permissions-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 181,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 8,
    featureId: null,
    key: 'orders-payments-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 182,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 9,
    featureId: null,
    key: 'hiring-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 183,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 10,
    featureId: null,
    key: 'restaurant-configurations-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 184,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: null,
    key: 'shift-scheduler-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 185,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: null,
    key: 'shift-pool-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 186,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 13,
    featureId: null,
    key: 'reports-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 187,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 35,
    featureId: null,
    key: 'task-manager-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 188,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 36,
    featureId: null,
    key: 'aio-care-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 189,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 37,
    featureId: null,
    key: 'docvault-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 190,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 38,
    featureId: null,
    key: 'dashboard-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 191,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: null,
    key: 'lost-&-found-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 192,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 40,
    featureId: null,
    key: 'employee-payroll-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 193,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 41,
    featureId: null,
    key: 'order-form-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 194,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 42,
    featureId: null,
    key: 'pay-management-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 195,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 1,
    featureId: 1,
    key: 'business-information-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 196,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 1,
    featureId: 1,
    key: 'business-information-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 197,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 1,
    featureId: 1,
    key: 'business-information-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 198,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 1,
    featureId: 2,
    key: 'restaurant-information-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 199,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 1,
    featureId: 2,
    key: 'restaurant-information-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 200,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 1,
    featureId: 2,
    key: 'restaurant-information-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 201,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 1,
    featureId: 3,
    key: 'bank-accounts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 202,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 1,
    featureId: 3,
    key: 'bank-accounts-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 203,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 1,
    featureId: 3,
    key: 'bank-accounts-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 204,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 1,
    featureId: 3,
    key: 'bank-accounts-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 205,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 1,
    featureId: 3,
    key: 'bank-accounts-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 206,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 1,
    featureId: 4,
    key: 'credit-card-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 207,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 1,
    featureId: 4,
    key: 'credit-card-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 208,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 1,
    featureId: 4,
    key: 'credit-card-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 209,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 1,
    featureId: 4,
    key: 'credit-card-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 210,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 1,
    featureId: 4,
    key: 'credit-card-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 211,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 1,
    featureId: 5,
    key: 'recurring-payment-method-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 212,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 1,
    featureId: 5,
    key: 'recurring-payment-method-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 213,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 1,
    featureId: 5,
    key: 'recurring-payment-method-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 214,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 215,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 216,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 217,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 218,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 219,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 3,
    featureId: 13,
    key: 'view-other-employees-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 220,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 3,
    featureId: 13,
    key: 'view-other-employees-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 221,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 3,
    featureId: 14,
    key: 'export-timecards-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 222,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 3,
    featureId: 14,
    key: 'export-timecards-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 223,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 3,
    featureId: 111,
    key: 'edit-time-entries-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 224,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 3,
    featureId: 111,
    key: 'edit-time-entries-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 225,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 3,
    featureId: 111,
    key: 'edit-time-entries-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 226,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 227,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 228,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 4,
    featureId: 112,
    key: 'view-other-employees-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 229,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 4,
    featureId: 112,
    key: 'view-other-employees-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 230,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 231,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 232,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 5,
    featureId: 113,
    key: 'approve-requests-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 233,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 5,
    featureId: 114,
    key: 'request-tab-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 234,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 5,
    featureId: 115,
    key: 'processed-tab-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 235,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 5,
    featureId: 116,
    key: 'my-own-tab-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 236,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: 17,
    key: 'resend-invite-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 237,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: 18,
    key: 'deactivate-employee-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 238,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: 19,
    key: 're-activate-employee-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 239,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: 20,
    key: 'personal-information-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 240,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 20,
    key: 'personal-information-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 241,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 20,
    key: 'personal-information-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 242,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 243,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 244,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 245,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 246,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 247,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 248,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 249,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 250,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 251,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 252,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: 23,
    key: 'documents-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 253,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 23,
    key: 'documents-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 254,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 23,
    key: 'documents-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 255,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: 120,
    key: 'employees-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 256,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 6,
    featureId: 120,
    key: 'employees-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 257,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 120,
    key: 'employees-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 258,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 120,
    key: 'employees-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 259,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 6,
    featureId: 120,
    key: 'employees-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 260,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: 121,
    key: 'details-button-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 261,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 7,
    featureId: 24,
    key: 'roles-permissions-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 262,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 7,
    featureId: 24,
    key: 'roles-permissions-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 263,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 8,
    featureId: 25,
    key: 'view-order-details-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 264,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 8,
    featureId: 26,
    key: 'refund-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 265,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 9,
    featureId: 27,
    key: 'share-job-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 266,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 10,
    featureId: 28,
    key: 'general-settings-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 267,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 10,
    featureId: 28,
    key: 'general-settings-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 268,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 10,
    featureId: 28,
    key: 'general-settings-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 269,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 10,
    featureId: 29,
    key: 'device-settings-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 270,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 10,
    featureId: 29,
    key: 'device-settings-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 271,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 10,
    featureId: 29,
    key: 'device-settings-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 272,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 10,
    featureId: 30,
    key: 'online-ordersing-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 273,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 10,
    featureId: 30,
    key: 'online-ordersing-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 274,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 10,
    featureId: 30,
    key: 'online-ordersing-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 275,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 32,
    key: 'duplicate-shift-button-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 276,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 33,
    key: 'release-other-employees-shift-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 277,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 34,
    key: 'release-shifts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 278,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 35,
    key: 'assign-to-another-employee-button-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 279,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 117,
    key: 'shifts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 280,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 11,
    featureId: 117,
    key: 'shifts-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 281,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 11,
    featureId: 117,
    key: 'shifts-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 282,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 11,
    featureId: 117,
    key: 'shifts-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 283,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 11,
    featureId: 117,
    key: 'shifts-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 284,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: 36,
    key: 'pool-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 285,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 12,
    featureId: 36,
    key: 'pool-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 286,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 12,
    featureId: 36,
    key: 'pool-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 287,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: 37,
    key: 'pool-view-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 288,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: 38,
    key: 'approve-requests-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 289,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 13,
    featureId: 39,
    key: 'net-sales-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 290,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 13,
    featureId: 40,
    key: 'labour-cost-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 291,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 13,
    featureId: 41,
    key: 'comps-voids-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 292,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 13,
    featureId: 42,
    key: 'top-sellers-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 293,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 13,
    featureId: 43,
    key: 'break-violations-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 294,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 35,
    featureId: 85,
    key: 're-assign-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 295,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 35,
    featureId: 122,
    key: 'tasks-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 296,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 35,
    featureId: 122,
    key: 'tasks-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 297,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 35,
    featureId: 122,
    key: 'tasks-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 298,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 35,
    featureId: 122,
    key: 'tasks-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 299,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 35,
    featureId: 122,
    key: 'tasks-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 300,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 36,
    featureId: 87,
    key: 'p2p-chat-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 301,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 36,
    featureId: 88,
    key: 'approve-button-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 302,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 303,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 304,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 305,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 306,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 307,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 308,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 309,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 310,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 311,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 312,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 313,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 314,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 315,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 316,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 317,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 38,
    featureId: 7,
    key: 'overview-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 318,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 38,
    featureId: 7,
    key: 'overview-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 319,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 38,
    featureId: 8,
    key: 'staff-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 320,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 38,
    featureId: 8,
    key: 'staff-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 321,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 38,
    featureId: 9,
    key: 'office-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 322,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 38,
    featureId: 9,
    key: 'office-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 323,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 38,
    featureId: 10,
    key: 'marketing-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 324,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 38,
    featureId: 10,
    key: 'marketing-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 325,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 326,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 327,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 328,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 329,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 330,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 331,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 332,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 333,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 334,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 335,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: 127,
    key: 'mark-as-retrieved-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 336,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 40,
    featureId: 128,
    key: 'pay-schedules-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 337,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 40,
    featureId: 128,
    key: 'pay-schedules-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 338,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 40,
    featureId: 128,
    key: 'pay-schedules-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 339,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 40,
    featureId: 128,
    key: 'pay-schedules-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 340,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 40,
    featureId: 128,
    key: 'pay-schedules-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 341,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 40,
    featureId: 129,
    key: 'payroll-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 342,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 40,
    featureId: 129,
    key: 'payroll-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 343,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 40,
    featureId: 129,
    key: 'payroll-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 344,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 40,
    featureId: 129,
    key: 'payroll-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 345,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 40,
    featureId: 129,
    key: 'payroll-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 346,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 41,
    featureId: 130,
    key: 'order-forms-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 347,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 42,
    featureId: 131,
    key: 'view-others-pay-stubs-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 348,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 42,
    featureId: 132,
    key: 'view-own-paystubs-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1276,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: null,
    featureId: null,
    key: 'pos-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1277,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: null,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1278,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: null,
    key: 'table-layout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1279,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 16,
    featureId: null,
    key: 'menu-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1280,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: null,
    key: 'ticket-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1281,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: null,
    key: 'header-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1282,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: null,
    key: 'dashboard-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1283,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: null,
    key: 'cashdrawer-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1284,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: null,
    key: 'payments-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1285,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: 45,
    key: 'login-without-clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1286,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: 46,
    key: 'device-status-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1287,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: 133,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1288,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: 47,
    key: 'table-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1289,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: 48,
    key: 'table-status-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1290,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: 49,
    key: 'switch-floors-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1291,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: 50,
    key: 'view-seating-capacity-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1292,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 16,
    featureId: 51,
    key: 'comp-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1293,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 55,
    key: 'service-charges-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1294,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 56,
    key: 'custom-item-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1295,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 57,
    key: 'tax-exempt-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1296,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 58,
    key: 'change-table-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1297,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 59,
    key: 'change-server-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1298,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 60,
    key: 'void-order-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1299,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 61,
    key: 'discounts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1300,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 62,
    key: 'settings-hamburger-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1301,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 63,
    key: 'orders-hub-hamburger-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1302,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 64,
    key: 'restaurant-type-hamburger-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1303,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 65,
    key: 'cashdrawer-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1304,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 66,
    key: 'aio-help-center-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1305,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 67,
    key: 'my-day-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1306,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 68,
    key: 'overview-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1307,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 69,
    key: 'z-report-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1308,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 70,
    key: 'employee-attendance-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1309,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 71,
    key: 'other-stations-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1310,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 72,
    key: 'my-station-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1311,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 73,
    key: 'host-drawer-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1312,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 74,
    key: 'logs-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1313,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 75,
    key: 'adjust-starting-balance-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1314,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 76,
    key: 'close-drawer-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1315,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 26,
    key: 'refund-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1316,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 53,
    key: 'update-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1317,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 54,
    key: 'adjust-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1574,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: null,
    featureId: null,
    key: 'mpos-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1575,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 22,
    featureId: null,
    key: 'login-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1576,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 23,
    featureId: null,
    key: 'table-layout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1577,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 24,
    featureId: null,
    key: 'menu-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1578,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: null,
    key: 'ticket-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1579,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 22,
    featureId: 77,
    key: 'login-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1580,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 23,
    featureId: 78,
    key: 'other-tables-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1581,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 24,
    featureId: 51,
    key: 'comp-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1582,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 24,
    featureId: 79,
    key: 'void-items-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1583,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 24,
    featureId: 80,
    key: 'edit-service-charge-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1584,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 57,
    key: 'tax-exempt-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1585,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 58,
    key: 'change-table-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1586,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 59,
    key: 'change-server-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1587,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 60,
    key: 'void-order-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1588,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 61,
    key: 'discounts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1589,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 81,
    key: 'custom-item-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1754,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 4,
    moduleId: null,
    featureId: null,
    key: 'web-dash-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1755,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 4,
    moduleId: 17,
    featureId: null,
    key: 'payments-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1756,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 4,
    moduleId: 27,
    featureId: null,
    key: 'menu-manager-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1757,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 4,
    moduleId: 28,
    featureId: null,
    key: 'marketing-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1758,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 17,
    featureId: 97,
    key: 'sales-tax-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1759,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 17,
    featureId: 97,
    key: 'sales-tax-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1760,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 17,
    featureId: 97,
    key: 'sales-tax-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1761,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 17,
    featureId: 97,
    key: 'sales-tax-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1762,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 17,
    featureId: 98,
    key: 'comps-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1763,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 17,
    featureId: 98,
    key: 'comps-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1764,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 17,
    featureId: 98,
    key: 'comps-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1765,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 17,
    featureId: 98,
    key: 'comps-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1766,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 17,
    featureId: 99,
    key: 'service-charge-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1767,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 17,
    featureId: 99,
    key: 'service-charge-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1768,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 17,
    featureId: 99,
    key: 'service-charge-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1769,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 17,
    featureId: 99,
    key: 'service-charge-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1770,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 27,
    featureId: 90,
    key: 'menu-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1771,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 90,
    key: 'menu-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1772,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 90,
    key: 'menu-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1773,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 27,
    featureId: 90,
    key: 'menu-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1774,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 27,
    featureId: 91,
    key: 'category-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1775,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 91,
    key: 'category-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1776,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 91,
    key: 'category-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1777,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 27,
    featureId: 91,
    key: 'category-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1778,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 27,
    featureId: 92,
    key: 'Item-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1779,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 92,
    key: 'Item-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1780,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 92,
    key: 'Item-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1781,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 27,
    featureId: 92,
    key: 'Item-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1782,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 27,
    featureId: 93,
    key: 'modifier-group-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1783,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 93,
    key: 'modifier-group-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1784,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 93,
    key: 'modifier-group-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1785,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 27,
    featureId: 93,
    key: 'modifier-group-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1786,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 27,
    featureId: 94,
    key: 'modifier-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1787,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 94,
    key: 'modifier-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1788,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 94,
    key: 'modifier-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1789,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 27,
    featureId: 94,
    key: 'modifier-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1790,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 27,
    featureId: 95,
    key: 'modifier-option-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1791,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 95,
    key: 'modifier-option-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1792,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 95,
    key: 'modifier-option-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1793,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 27,
    featureId: 95,
    key: 'modifier-option-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1794,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 27,
    featureId: 96,
    key: 'tags-&-allergens-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1795,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 96,
    key: 'tags-&-allergens-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1796,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 96,
    key: 'tags-&-allergens-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1797,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 27,
    featureId: 96,
    key: 'tags-&-allergens-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1798,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 100,
    key: 'guestbook-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1799,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 100,
    key: 'guestbook-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1800,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 100,
    key: 'guestbook-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1801,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 100,
    key: 'guestbook-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1802,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 101,
    key: 'brandbook-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1803,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 101,
    key: 'brandbook-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1804,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 101,
    key: 'brandbook-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1805,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 101,
    key: 'brandbook-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1806,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 102,
    key: 'deals-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1807,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 102,
    key: 'deals-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1808,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 102,
    key: 'deals-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1809,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 102,
    key: 'deals-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1810,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 103,
    key: 'website-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1811,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 103,
    key: 'website-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1812,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 103,
    key: 'website-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1813,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 103,
    key: 'website-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1814,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 104,
    key: 'spotlights-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1815,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 104,
    key: 'spotlights-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1816,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 104,
    key: 'spotlights-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1817,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 104,
    key: 'spotlights-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1818,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 105,
    key: 'campaigns-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1819,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 105,
    key: 'campaigns-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1820,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 105,
    key: 'campaigns-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1821,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 105,
    key: 'campaigns-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1822,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 106,
    key: 'journeys-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1823,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 106,
    key: 'journeys-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1824,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 106,
    key: 'journeys-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1825,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 106,
    key: 'journeys-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1826,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 107,
    key: 'loyalty-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1827,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 107,
    key: 'loyalty-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1828,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 107,
    key: 'loyalty-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1829,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 107,
    key: 'loyalty-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1830,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 108,
    key: 'dashboard-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1831,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 108,
    key: 'dashboard-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1832,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 108,
    key: 'dashboard-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1833,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 108,
    key: 'dashboard-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1834,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 109,
    key: 'gift-cards-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1835,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 109,
    key: 'gift-cards-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1836,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 109,
    key: 'gift-cards-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1837,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 109,
    key: 'gift-cards-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1991,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 139,
    key: 'guest-segments-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1992,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 139,
    key: 'guest-segments-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1999,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 140,
    key: 'guest-spend-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2000,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 140,
    key: 'guest-spend-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2006,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 4,
    moduleId: 45,
    featureId: null,
    key: 'integrations-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2010,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 45,
    featureId: null,
    key: 'integrations-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2015,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 141,
    key: 'review-management-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2016,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 141,
    key: 'review-management-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2622,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 4,
    moduleId: 29,
    featureId: null,
    key: 'inventory-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2707,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 148,
    key: 'ingredients-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2708,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 148,
    key: 'ingredients-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2709,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 148,
    key: 'ingredients-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2710,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 148,
    key: 'ingredients-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2711,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 149,
    key: 'orders-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2712,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 149,
    key: 'orders-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2713,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 149,
    key: 'orders-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2714,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 149,
    key: 'orders-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2715,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 150,
    key: 'recipes-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2716,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 150,
    key: 'recipes-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2717,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 150,
    key: 'recipes-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2718,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 150,
    key: 'recipes-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2719,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 151,
    key: 'invoices-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2720,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 151,
    key: 'invoices-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2721,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 151,
    key: 'invoices-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2722,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 151,
    key: 'invoices-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2723,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 152,
    key: 'storage-areas-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2724,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 152,
    key: 'storage-areas-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2725,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 152,
    key: 'storage-areas-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2726,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 152,
    key: 'storage-areas-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2727,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 153,
    key: 'vendors-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2728,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 153,
    key: 'vendors-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2729,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 153,
    key: 'vendors-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2730,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 153,
    key: 'vendors-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2731,
    roleId: 5,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 154,
    key: 'non-ingredients-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2732,
    roleId: 5,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 154,
    key: 'non-ingredients-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2733,
    roleId: 5,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 154,
    key: 'non-ingredients-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2734,
    roleId: 5,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 154,
    key: 'non-ingredients-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3459,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 17,
    featureId: 134,
    key: 'tenders-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3462,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 17,
    featureId: 134,
    key: 'tenders-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3479,
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 43,
    featureId: 53,
    key: 'update-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
];

export const websiteModulePermission = [
  websiteModule['website-visible'],
  websiteModule['website-announcements-create'],
  websiteModule['website-announcements-read'],
  websiteModule['website-announcements-edit'],
  websiteModule['website-announcements-delete'],

  websiteModule['website-builder-create'],
  websiteModule['website-builder-read'],
  websiteModule['website-builder-edit'],
  websiteModule['website-builder-delete'],

  websiteModule['website-seo-create'],
  websiteModule['website-seo-read'],
  websiteModule['website-seo-edit'],
  websiteModule['website-seo-delete'],

  websiteModule['website-templates-create'],
  websiteModule['website-templates-read'],
  websiteModule['website-templates-edit'],
  websiteModule['website-templates-delete'],
];

export const managerDefaultPermissionForNewModules = [
  ...tenderCashDrawerFeatures,
  ...roleAndPermissionsModulePermissions,
  ...tipsPoolingModulePermissions,
  ...settingsModulePermission,
  ...reviewManagementFeaturePermission,
  ...visibleCheckPermissions,
  ...websiteModulePermission,
  ...payrollModulePermissions,
];

export const managerDefaultPosPermission = [
  tableLayoutPosModule['assign-server-visible'],
  orderHubPosModule['order-hub-visible'],
  orderHubPosModule['ticket-visible'],
  paymentPosModule['tenders-visible'],
];

export const managerDefaultMenuBoardPermission = [...menuBoardPermission];

export const managerDefaultCateringFeaturePermission = [
  cateringModulePermission['catering-visible'],
  cateringModulePermission['dashboard-create'],
  cateringModulePermission['dashboard-read'],
  cateringModulePermission['dashboard-edit'],
  cateringModulePermission['invoice-management-read'],
  cateringModulePermission['invoice-management-edit'],
  cateringModulePermission['package-configuration-create'],
  cateringModulePermission['package-configuration-read'],
  cateringModulePermission['package-configuration-edit'],
  cateringModulePermission['package-configuration-delete'],
  cateringModulePermission['email-templates-read'],
];
export const managerCloseOutPermission = [dashboardPosModule['closeout-visible']];
export const managerPosSettingsPermissions = [...settingsPosFeaturePermissions];
